/**
 * `deepLink` iz obavijesti → ruta u portalu.
 *
 * Server šalje jednu, jezično neutralnu putanju (`/poruke/<id>`, `/kalendar`)
 * jer ne zna tko je primatelj ni kako izgleda rutno stablo portala. Portal ima
 * dva stabla: klijentsko na korijenu i trenersko iza `/trener`. Bez prijevoda
 * trener koji klikne obavijest o poruci sleti na provjeru uloge i završi na
 * svojoj početnoj — obavijest ga odvede bilo kamo osim na poruku.
 *
 * Živi u ugovoru, a ne u portalu, jer isti prijevod treba i API: web push nosi
 * gotovu poveznicu koju service worker otvara bez ikakvog znanja o ulogama.
 */

/** Putanje koje kod trenera žive iza `/trener`. */
const TRAINER_PREFIXED = ['/poruke', '/check-in', '/klijenti', '/programi', '/vjezbe'];

export function notificationRoute(
  deepLink: string | null | undefined,
  role: string | undefined,
): string | null {
  if (!deepLink || !deepLink.startsWith('/')) return null;
  const trainer = role === 'trainer' || role === 'admin';

  if (deepLink.startsWith('/trener/') || deepLink === '/trener') {
    // Trenerska putanja klijentu ne znači ništa; ne vodimo ga na zabranjen ekran.
    return trainer ? deepLink : null;
  }
  if (deepLink.startsWith('/admin')) return role === 'admin' ? deepLink : null;

  if (trainer) {
    const base = TRAINER_PREFIXED.find((p) => deepLink === p || deepLink.startsWith(`${p}/`));
    return base ? `/trener${deepLink}` : null;
  }
  return deepLink;
}
